import React from 'react';

import BrandLogo from './BrandLogo';

import { useVendor } from '../context/VendorContext';

const MENU = [
  { section: 'Trabajo' },
  { id: 'dashboard', icon: '🏠', label: 'Inicio' },
  { id: 'pedido', icon: '🛍️', label: 'Nuevo pedido' },
  { id: 'mis-clientes', icon: '👥', label: 'Mis clientes' },
  { id: 'historial', icon: '📅', label: 'Historial' },
  { id: 'pedidos', icon: '📋', label: 'Mis pedidos' },
];

export default function Sidebar({
  page,
  onNavigate,
  mode,
  onClose,
  className = '',
  collapsed = false,
  onToggleCollapse,
  pedidosBadge = 0,
}) {
  const { appName, vendedor, clearVendedor } = useVendor();

  return (
    <aside className={`sidebar ${className}`.trim()}>
      <div className="sidebar-brand">
        <BrandLogo size="sm" />
        {!collapsed ? (
          <>
            <span className="sidebar-app-name">{appName}</span>
            {vendedor ? <span className="sidebar-vendor-pill">{vendedor.nombre}</span> : null}
            <span className="sidebar-mode">{mode || 'Pedidos'}</span>
            {vendedor ? (
              <button type="button" className="sidebar-switch-vendor" onClick={clearVendedor}>
                Cerrar sesión
              </button>
            ) : null}
          </>
        ) : vendedor ? (
          <span className="sidebar-vendor-initial" title={vendedor.nombre}>
            {vendedor.nombre.charAt(0)}
          </span>
        ) : null}
      </div>

      <nav className="sidebar-nav">
        {MENU.map((item, i) =>
          item.section ? (
            !collapsed ? (
              <span key={`sec-${i}`} className="sidebar-section">{item.section}</span>
            ) : (
              <span key={`sec-${i}`} className="sidebar-section-divider" aria-hidden />
            )
          ) : (
            <button
              key={item.id}
              type="button"
              title={collapsed ? item.label : undefined}
              className={`sidebar-link ${page === item.id || (item.id === 'pedidos' && page === 'pedido-detalle') ? 'active' : ''}`}
              onClick={() => {
                onNavigate(item.id);
                onClose?.();
              }}
            >
              <span className="sidebar-link-icon">{item.icon}</span>
              {!collapsed ? (
                <span className="sidebar-link-label">
                  {item.label}
                  {item.id === 'pedidos' && pedidosBadge > 0 ? (
                    <span className="sidebar-link-badge">{pedidosBadge}</span>
                  ) : null}
                </span>
              ) : item.id === 'pedidos' && pedidosBadge > 0 ? (
                <span className="sidebar-link-badge collapsed-badge">{pedidosBadge}</span>
              ) : null}
            </button>
          )
        )}
      </nav>

      {onToggleCollapse ? (
        <button
          type="button"
          className="sidebar-collapse-btn"
          onClick={onToggleCollapse}
          title={collapsed ? 'Expandir menú' : 'Minimizar menú'}
          aria-label={collapsed ? 'Expandir menú' : 'Minimizar menú'}
        >
          {collapsed ? '»' : '«'}
        </button>
      ) : null}
    </aside>
  );
}
